module.exports = __webpack_public_path__ + "static/media/sport-medicines.530d5887.jpg";